import React, { useEffect, useState } from "react";
import CurrencyFormat from "react-currency-format";
import { proceedLoanOffer } from "../../../redux/slices/financer";
import { dispatch } from "../../../redux/store";
import axiosInstance from "../../../utils/axios";
import { currencySymbol, LoanDate } from "../../../utils/helpers";
import PendingIcon from "../../PendingIcon";
import ChatBox from "./ChatBox";
import "./ChatSection.css";
import { getMessages } from "../../../redux/slices/loanOffers";
export default function ConversationSection({ loanId }) {
  const [userLoading, setUserLoading] = useState(true);
  const [userChatsLoading, setUserChatsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [userFetchError, setUserFetchError] = useState(false);
  const [messages, setMessages] = useState([]);
  const [conversations, setConversations] = useState([]);
  useEffect(() => {
    dispatch(proceedLoanOffer(loanId))
      .unwrap()
      .then(async (res) => {
        if (res.success) {
          setUser(res.loanOffer);
          setUserLoading(false);
          dispatch(getMessages(res.loanOffer.id))
            .unwrap()
            .then((res) => {
              if (res.success) {
                setConversations(res?.offerMessages);
              }
            });
          const msg = await axiosInstance.get(
            `get-financer-offers/${res.loanOffer.id}`
          );
          if (msg.data.success) {
            setMessages(msg.data?.financierOffers);
            setUserChatsLoading(false);
          }
        } else {
          setUserFetchError(true);
        }
      });

    setTimeout(() => {
      if (userLoading) {
        setUserLoading(false);
      }
      if (userChatsLoading) {
        setUserChatsLoading(false);
      }
    }, 3000);

    return () => {};
  }, []);

  return (
    <>
      <div className="card my-3">
        <>
          {userLoading ? (
            <span className="spinner-border"></span>
          ) : (
            user !== null &&
            user !== undefined &&
            user !== "" && (
              <div
                style={{
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                  paddingTop: "1rem",
                }}
              >
                <div className="onboarding-title">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="onboard_flexhead d-flex justify-content-between align-items-center">
                        <h4 className="">User Information</h4>
                        {/* <div className="">
                          <div className="status btn">
                            <PendingIcon /> Pending
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row align-items-center flex-row-reverse">
                  <div className="col-lg-12">
                    <div className="about-text go-to">
                      <div className="row about-list">
                        <div className="col-md-4">
                          <div className="media">
                            <label>Name:</label>
                            <p>
                              {user?.user?.first_name}&nbsp;
                              {user?.user?.last_name}
                            </p>
                          </div>
                          <div className="media">
                            <label>File No. :</label>
                            <p>{user?.loan_application_id}</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="media">
                            <label> Rate Of Interest:</label>
                            <p>{user?.requested_roi} %</p>
                          </div>
                          <div className="media">
                            <label>Amount:</label>
                            <p>
                              {currencySymbol()}
                              {
                                <CurrencyFormat
                                  value={user?.amount_requested}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                />
                              }
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="media">
                            <label>Tenure:</label>
                            <p>{user?.requested_tenure} Months</p>
                          </div>
                          <div className="media">
                            <label>Created Date :</label>
                            <p>{<LoanDate datestring={user?.created_at} />}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </>
      </div>
      <ChatBox
        user={user}
        messages={messages}
        loanId={user?.id}
        setMessages={setMessages}
        conversations={conversations}
        setConversations={setConversations}
      />
    </>
  );
}
